import {
  ChangeDetectorRef,
  Directive,
  forwardRef,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  Optional,
} from '@angular/core';
import { ControlContainer } from '@angular/forms';
import {
  FormDefinition,
  FormDirective,
} from 'eurogard-forms';
import { equals } from '@rxap/utilities';
import { Subscription } from 'rxjs';
import {
  debounceTime,
  distinctUntilChanged,
  tap,
} from 'rxjs/operators';
import { TableFilterService } from './table-filter.service';
import { EUROGARD_TABLE_FILTER_FORM_DEFINITION } from './tokens';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'table[eurogard-filter-header-row]',
  providers: [
    {
      provide: ControlContainer,
      // ignore coverage
      useExisting: forwardRef(() => FilterHeaderRowDirective),
    },
  ],
  standalone: true,
})
export class FilterHeaderRowDirective
  extends FormDirective
  implements OnInit, OnDestroy {

  @Input('eurogard-filter-header-row')
  public override set useFormDefinition(value: FormDefinition | '') {
    if (value) {
      this._formDefinition = value as any;
      this.form = value.rxapFormGroup;
    }
  }

  private _subscription?: Subscription;

  constructor(
    private readonly tableFilter: TableFilterService,
    cdr: ChangeDetectorRef,
    @Optional()
    @Inject(EUROGARD_TABLE_FILTER_FORM_DEFINITION)
      formDefinition: FormDefinition | null,
  ) {
    super(cdr, formDefinition);
  }

  public override ngOnInit() {
    super.ngOnInit();
    this._subscription = new Subscription();
    this._subscription.add(this.tableFilter.reset$.subscribe(() => this.form.reset()));
    this._subscription.add(this.form.value$
                             .pipe(
                               debounceTime(1000),
                               distinctUntilChanged((a, b) => equals(a, b)),
                               tap(values => this.tableFilter.setMap(values)),
                             )
                             .subscribe());
  }

  public override ngOnDestroy() {
    super.ngOnDestroy();
    this._subscription?.unsubscribe();
  }
}
